import '../../App.scss';
import ScoreChart from "./scoreChart"

import { Chart as ChartJS, ArcElement, Tooltip, Legend, scales } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function CharactersCast(props) {

	const ccData = props.ccData;
	var chars = [];
	var actors = [];
	for (let i = 0; i < ccData.length; i++) {
		if (!chars.includes(ccData[i].characterName)) {
			chars.push(ccData[i].characterName);
			actors.push(ccData[i].actorName);
		}
	}

	// const listItems = chars.map(char => <li>{char}</li>);

	var castcharlist = []
	for (let i = 0; i < chars.length; i++) {
		castcharlist.push(<li key = {i}>{chars[i]} <span className='actor'>({actors[i]})</span></li>);
	}

    return (
		<div className='align-left section-header white flex-col gap-24'>
				<div className="flex-col">
					<h1>Characters and Cast</h1>
				</div>	

				<div className='flex-item align-top gap-24'>
					<ScoreChart 
						chartData={props.chartData}
					/>
					<ul className='flex-col indvtext-lists'>
						{castcharlist}
					</ul>
				</div>
		</div>
    )

}